
var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

function setCookie(cname,cvalue,exdays) {
	var d = new Date();
	d.setTime(d.getTime() + (exdays*24*60*60*1000));
	var expires = "expires=" + d.toGMTString();
	document.cookie = cname+"="+cvalue+"; "+expires+"; path=/";
}

function getCookie(cname) {
	var name = cname + "=";
	var ca = document.cookie.split(';');
	for(var i=0; i<ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0)==' ') c = c.substring(1);
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}

function smoothScroll(el) {
	var target = document.getElementById(el.hash.slice(1));
	var offset = 100;
	var top = target.offsetTop - offset;
	var duration = 1000;
	window.scrollTo({
		top: top,
		behavior: 'smooth',
		duration: duration
	});
}

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();
		smoothScroll(e.target);
    });
});

function CustomCeil(number, digits) {
  var factor = Math.pow(10, digits);
  return Math.ceil(number*factor) / factor;
}

const cart_obj = document.getElementById('kuji-cart');
let cart = JSON.parse(localStorage.getItem("kuji_cart"));

function update_cart(cart){
	cart_json = JSON.stringify((cart))
	localStorage.setItem("kuji_cart", cart_json);

	build_cart(cart);
}

var currentDate = new Date(current_date);

function check_date(date){
	const seconds = (currentDate.getTime() - date.getTime()) / 1000;
	const hours = (seconds / 60) / 60;
	return hours
}

function update_cart_product(cart,merchant_cart,item,product){
	//console.log('update data: '+product.title);
	item.product = product
	variants = item.product.variants
	//console.log( variants )
	variantIndex = variants.findIndex((obj => obj.barcode == item.id));

	//TO DO:Need to update Arigato to only delete variants if inventory changes have been identified, otherwise just republish
	if ( variantIndex != -1 ) {
		if ( product.variants[variantIndex].inventory_quantity >= item.quantity) {
			item.available = true
			console.log('its available')
		} else {
			item.available = false
			console.log('oh no sold out')
		}
		if ( product.variants[variantIndex].inventory_quantity < 3) {
			console.log('Low in stock:'+product.title)
		}

		update_cart(cart)
	} else {
		//console.log( 'looking for: '+item.id)
		//TO DO: variant missing - should we do something?
	}
}

//check if cart product has been updated by Arigato
function check_cart_product(cart,merchant_cart,item){
	fetch('/products/'+item.product.handle+"?view=custom_json")
	.then((response) => {
		return new Promise((resolve) => response.json()
		.then((json) => resolve({
			status: response.status,
			ok: response.ok,
			json,
		})));
	}).then(({ status, json, ok }) => {
		switch (status) {
		case 400:
			alert('400 error - product deleted?');
			break;
		case 201:
			break;
		case 200:
			const product = json
			const published_at = new Date(product.published_at);
			if ( check_date(published_at) < 0.5 ) {
				//console.log('rechecked and updating')
				//product data has been updated in the last 1/5 hours so lets use that
				update_cart_product(cart,merchant_cart,item,product);
			} else {
				//Recheck in 15 sec
				setTimeout(function(){
					//console.log('recheck data')
					check_cart_product(cart,merchant_cart,item)
				}, 15000);
			}
			break;
		case 500:
			break;
		default:
			//Any default tasks
		}
	})
}

function check_cart_age(){
	for (var merchant in cart) {
		const merchant_cart = cart[merchant]
		const merchant_items = merchant_cart.items
		for (var line_item in merchant_items) {
			let item = merchant_items[line_item]
			const item_published_at = new Date(item.product.published_at);
			//console.log( check_date(published_at) )
			if ( check_date(item_published_at) > 1) {
				//Current data older than 1 hour so recheck
				console.log( item.product.handle )
				fetch('/products/'+item.product.handle+"?view=custom_json")
				.then((response) => {
					return new Promise((resolve) => response.json()
					.then((json) => resolve({
						status: response.status,
						ok: response.ok,
						json,
					})));
				}).then(({ status, json, ok }) => {
					switch (status) {
					case 400:
						alert('400 error - product deleted?');
						break;
					case 201:
						break;
					case 200:
						product = json
						//console.log( product )
						const published_at = new Date(product.published_at);
						//console.log( check_date(published_at) )
						if ( check_date(published_at) < 3 ) {
							//kuji product data has been updated in the last 3 hours so lets reuse that
							//TO DO:less than 3 hours, update product (should change to 30mins)
							update_cart_product(cart,merchant_cart,item,product);
						} else {
							//console.log('run Arigato update on '+product.title)
							//old data, we need to trigger new Arigato product update
							//Then we need to keep checking for fresh data
							//console.log ( product)
							let total_qty = 0;
							for (var variant in product.variants) {
								total_qty = total_qty + product.variants[variant].inventory_quantity
							}
							const request_data = {
								"product_id": product.id,
								"product_qty": total_qty,
								"merchant_product_id": product.mechant_product_id,
								"merchant_handle": merchant_cart.handle
							};
							//console.log( request_data )

							/* buggy - TURNED OFF
							var headers = new Headers();
							headers.append('Accept', 'application/json');
							headers.append('Content-Type', 'application/json');
							fetch('https://apps.bonify.io/api/triggers/workflows/18281/226256/2c81688a7617b361a186775104f8b71e', {
								method: 'POST',
								mode: 'no-cors',
								credentials: 'include',
								redirect: 'follow',
								headers: headers,
								body: JSON.stringify( request_data ),
							})
							.then(resp => {
								//console.log('Success:', resp);
								setTimeout(function(){
									console.log('first cart check')
									check_cart_product(cart,merchant_cart,item)
								}, 20000);

							}).catch(err => {
								console.log('Error:', err);
							});
							*/

						}
						break;
					case 500:
						break;
					default:
						//Any default tasks
					}
				})
			} else {
				//recent data less than 1h
				console.log('Current Data:'+item.product.title);
			}
		}
	}
}
check_cart_age();

function kuji_add_product(button){
	const product_info = button.closest('.product__info-wrapper');

	let product_var_qty = 1;

	const
		product_form_id = product_info.querySelector("[name=id]"),
		product_form_qty = product_info.querySelector("[name=quantity]");

	if ( product_form_qty != null && typeof(product_form_qty) != "undefined" ) {
		//check to see if we've enabled qty selector
		product_var_qty = product_form_qty.value;
	}

	const
		product_id = product_form_id.getAttribute('data-product_id'),
		merchant_title = product_form_id.getAttribute('data-merchant'),
		merchant_handle = product_form_id.getAttribute('data-merchant_handle'),
		merchant_currency = product_form_id.getAttribute('data-currency'),
		merchant_url = product_form_id.getAttribute('data-url'),
		merchant_multiple = product_form_id.getAttribute('data-multiple'),
		merchant_ratio = product_form_id.getAttribute('data-ratio'),
		merchant_type = product_form_id.getAttribute('data-type');

	const product_json = JSON.parse(document.getElementById('ProductJSON-'+product_id).textContent)
	//console.log(product_json)

	const product_data = {
		available: true,
		quantity: product_var_qty,
		id: product_form_id.getAttribute('data-id'),
		variant_id: product_form_id.value,
		title: product_form_id.getAttribute('data-title'),
		price: product_form_id.getAttribute('data-price'),
		product: product_json
	}

	function check_cart_merchant(cart,product_data){

		cartIndex = cart.findIndex((obj => obj.merchant == merchant_title));
		//console.log(cart)
		//console.log( cartIndex )
		if ( cartIndex !== -1) {
			//Merchant cart exists
			add_line_item(cart,cart[cartIndex],product_data)
		} else {
			//Create merchant cart and then recheck cart
			const new_cart = {
				"merchant": merchant_title,
				"handle": merchant_handle,
				"currency": merchant_currency,
				"url": merchant_url,
				"multiple": merchant_multiple,
				"ratio": merchant_ratio,
				"type": merchant_type,
				"items": []
			}
			cart.push(new_cart)
			//console.log( cart )
			check_cart_merchant(cart,product_data)
		}
	}

	function add_line_item(cart,merchant_cart,product_data) {
		let merchant_items = merchant_cart.items
		//console.log(merchant_cart);

		itemIndex = merchant_items.findIndex((obj => obj.variant_id == product_data.variant_id));
		if ( itemIndex !== -1) {
			//Line item exists, just update qty
			merchant_items[itemIndex].quantity = parseInt(merchant_items[itemIndex].quantity) + 1
		} else {
			//Create line item
			merchant_items.push(product_data)
		}
		console.log(cart)
		update_cart(cart)
	}

	function add_to_cart(cart,product_data) {

		check_cart_merchant(cart,product_data)

		//update_cart(product_data)

		//localStorage.setItem("kuji_cart", cart);

		//load_cart();
	}

	function load_cart(product_data) {
		if ( cart == null ) {
			// We should be creating a new cart.
			cart = []
			check_cart_merchant(cart,product_data)
		} else {
			check_cart_merchant(cart,product_data)
			//console.log( cart )
		}
	}

	load_cart(product_data);
	document.querySelector('.header__icon--cart').click();

}

document.addEventListener('click',function(e){
	let targetClassName = e.target.className;

	if (targetClassName !== null && typeof targetClassName === 'string') {
		const button = e.target || e.srcElement;

		if ( targetClassName.indexOf('kuji-trigger') == 0 ){
			//GENERAL RAFFLIN POPUP TRIGGER
			const
				merchant_handle = button.dataset.merchant_handle
				ticket_price = button.dataset.ticket
				cart_total = button.dataset.total,
				ticket_url = button.dataset.url,
				cart_min = button.dataset.cart_min;

			openkuji(cart,merchant_handle,ticket_price,cart_total,ticket_url,cart_min);
		}
		else if ( targetClassName.indexOf('kuji-add-to-cart') == 0 ){
			e.preventDefault();

			kuji_add_product(button)
		}
		else if ( targetClassName.indexOf('kuji-add-product') == 0 ){
			e.preventDefault();

			kuji_add_product(button)
			merchant_handle = button.getAttribute('data-merchant');

			setTimeout(function(){
				const win_cart_btn = cart_obj.querySelector('[data-merchant_handle="'+merchant_handle+'"]');

				//console.log(win_cart_btn)
				if ( win_cart_btn != null ) {
					win_cart_btn.click();
				}
			}, 500);
		}
		else if ( targetClassName.indexOf('cart-remove') == 0 ) {
			const merchant_cart = button.closest('.merchant-cart');
			const merchant_handle = merchant_cart.getAttribute('data-handle');
			const product_id = button.closest('.line-item').getAttribute('data-id');

			cartIndex = cart.findIndex((obj => obj.handle == merchant_handle));
			//console.log(cart)
			//console.log( cartIndex )

			//console.log( cartIndex )
			let merchant_items = cart[cartIndex].items

			itemIndex = merchant_items.findIndex((obj => obj.id == product_id));

			//remove item if zero
			merchant_items.splice(itemIndex, 1);
			if ( merchant_items.length == 0 ) {
				//remove cart if empty
				cart.splice(cartIndex, 1);
			}
			//console.log(cart)

			//merchant_items = merchant_items.filter(item => item.id != product_id);
			//cart = cart.filter(item => cart[cartIndex].items.id != product_id);
			update_cart(cart);
		}
		else if ( targetClassName.indexOf('qty-adjust') == 0 ) {
			const merchant_cart = button.closest('.merchant-cart');
			const merchant_handle = merchant_cart.getAttribute('data-handle');
			const product_id = button.closest('.line-item').getAttribute('data-id');

			cartIndex = cart.findIndex((obj => obj.handle == merchant_handle));

			let merchant_items = cart[cartIndex].items
			itemIndex = merchant_items.findIndex((obj => obj.id == product_id));
			let item = merchant_items[itemIndex]

			let new_qty = item.quantity - 1
			if ( button.getAttribute('data-type') == 'add' ) {
				new_qty = item.quantity + 1;
			}

			if ( new_qty == 0 ) {
				//remove item if zero
				merchant_items.splice(itemIndex, 1);
				if ( merchant_items.length == 0 ) {
					//remove cart if empty
					cart.splice(cartIndex, 1);
				}
				update_cart();
			} else {
				//update qty
				item.quantity = new_qty
				update_cart_product(cart,merchant_cart,item,item.product)
			}

		}
		else if ( targetClassName.indexOf('header__icon--cart') == 0 ) {

			e.preventDefault()
		}
	}


});

function build_cart(cart) {
	//console.log( cart )
	cart_obj.innerHTML = "";

	for (var merchant in cart) {
		console.log(cart);
		checkout_available = true;

		const m = cart[merchant]
		const merchant_cart_html = document.createElement("div");
		merchant_cart_html.setAttribute("class","merchant-cart");
		merchant_cart_html.setAttribute("data-handle",m.handle);

		let merchant_title = document.createElement("h4");
		merchant_title.innerHTML = m.merchant + ' Cart'
		merchant_cart_html.append(merchant_title)

		merchant_items = m.items
		let
			total_price = 0,
			raf_cart_items = '',
			raf_cart_products = '';

		for (var item of merchant_items){
			total_price = total_price + (item.price *item.quantity);

			if ( m.type == 'retail' ){
				//variant_id id on kuji store
				//id is id on merchant store
				raf_cart_items = raf_cart_items + item.id + ':' + item.quantity + ',';
			} else {
				//wholesale
				raf_cart_items = raf_cart_items + item.variant_id + ':' + item.quantity + ',';
			}
			raf_cart_products = raf_cart_products + item.product.title + ',';


			let item_title = item.title
			if ( item_title == 'Default Title') {
				item_title = ''
			}
			//console.log( item)

			let item_html = document.createElement("div")
			item_html.setAttribute("class","line-item");
			item_html.setAttribute("data-id",item.id);

			let item_img = ''
			if (item.product.featured_image) {
				item_img = item.product.featured_image.replace('.png','_200x.png').replace('.jpg','_200x.jpg')
			}
			item_html.innerHTML = `
				<div class="cart-img">
					<a href="/products/`+item.product.handle+`">
						<img src="`+item_img+`"/>
					</a>
				</div>`;

			let cart_details = document.createElement("div");
			cart_details.setAttribute("class","cart-details");

			cart_details.innerHTML =
				`<h4>
					<a href="/products/`+item.product.handle+`">`+item.product.vendor+`</a>
				</h4>
				<h5>
					<a href="/products/`+item.product.handle+`">`+item.product.title+`</a>
				</h5>
				<h5>`+item_title+`</h5>
				<p>RRP: `+Shopify.formatMoney(item.price, '${{amount}}')+`</p>

				<div class="item-qty">
					<button type="button" class="qty-adjust" data-type="minus">-</button>
					`+item.quantity+`
					<button type="button" class="qty-adjust" data-type="add">+</button>
				</div>`;

			const item_variants = item.product.variants;

			variantIndex = item_variants.findIndex((obj => obj.title == item.title));

			variants = item.product.variants
			//console.log( variants )
			variantIndex = variants.findIndex((obj => obj.title == item.title));

			cart_details.innerHTML += `<button type="button" class="cart-remove">×</button>`

			item_html.append(cart_details)

			if ( item.available == false ) {
				cart_details.innerHTML += `<div><p class="low-in-stock">Currently unavailable.</p></div>`;
				checkout_available = false
			} else if ( variantIndex != -1 && item.product.variants[variantIndex].inventory_quantity < 3) {
				cart_details.innerHTML += `<div><p class="low-in-stock">Low in stock, <a href="https://`+m.handle+`.myshopify.com/products/`+item.product.handle+`" target="_blank">check availability</a></p></div>`
			}

			merchant_cart_html.append(item_html);

			//console.log( item )
		}

		let merchant_footer = document.createElement("div");
		merchant_footer.setAttribute("class","merchant-footer");

		let cart_total = document.createElement("div");
		cart_total.setAttribute("class","merchant-total");
		cart_total.innerHTML = '<p>Total:'+Shopify.formatMoney(total_price, '${{amount}}')+'</p>';
		merchant_cart_html.append(cart_total)

		let merchant_shipping = document.createElement("a");
		merchant_shipping.setAttribute("class","merchant-shipping");
		merchant_shipping.innerHTML = 'Shipping details';
		merchant_shipping.setAttribute("href",'/');
		merchant_cart_html.append(merchant_shipping)


		let r_total = total_price / 10000.00;
		let r_min_cart = ''

		//Divide cart by 20 or 40 depending on 1/30 or 1/60 win rates
		const WR = m.ratio / 1.5
		let r_ticket_decimal = total_price / (WR * 100.0);
		//CustomCeil rounds up to nearest 0.1 decimal
		r_ticket_decimal = CustomCeil(r_ticket_decimal,1)

		if ( r_ticket_decimal <= 9.99 ) {
			//$0-$198 = $0 - $9.90 tickets
			r_ticket = r_ticket_decimal; // round to nearest 10c
			r_min_cart = (r_ticket * WR) - (WR / 10); // Maybe this should be more to give leway?
		} else if ( r_ticket_decimal > 9.99 && r_ticket_decimal <= 30 ) {
			//$200-$600 = $10 - $30 tickets
			r_ticket = Math.ceil(r_ticket_decimal*2)/2; // round to nearest 50c
			r_min_cart = (r_ticket * WR) - (WR / 2);
		} else if ( r_ticket_decimal > 30 && r_ticket_decimal <= 99 ) {
			//$601-$1,980 = $31 - $99 tickets
			r_ticket = Math.ceil( r_ticket_decimal ); // round to nearest 1
			r_min_cart = (r_ticket * WR) - WR;
		} else if ( r_ticket_decimal > 99 && r_ticket_decimal <= 500 ) {
			//$2,000-$10,000 = $100 - $500 tickets
			r_ticket =  5 * Math.ceil(r_ticket_decimal / 5); // round to nearest 5
			r_min_cart = (r_ticket * WR) - ( WR * 5 );
		}

		r_ticket = r_ticket * 1;
		if ( r_ticket < 30 ) {
			r_ticket = r_ticket.toFixed(2)
		}

		let url_geo = '';
		if ( m.currency == "nzd") {
			url_geo = 'en-nz/'
		} else if ( m.currency == "usd") {
			url_geo = 'en-us/'
		} else if ( m.currency == "cad") {
			url_geo = 'en-ca/'
		} else if ( m.currency == "gbp") {
			url_geo = 'en-gb/'
		} else if ( m.currency == "eur") {
			url_geo = 'en-eu/'
		}

		const https_kuji = 'https://kuji-app.myshopify.com/'+url_geo+'cart?h=';

		const kuji_url = https_kuji+m.handle+'&m='+m.merchant+'&c='+m.type+'&s=r&t='+total_price+'&x='+m.multiple+'&r='+m.ratio+'&i='+raf_cart_items+'&p='+raf_cart_products;

		if ( total_price <= 300000 ) {
			/* Popup Button */
			let ticket_btn = document.createElement("button");
			ticket_btn.setAttribute("class","kuji-trigger kuji-btn kuji-brand-btn button button--full-width button--primary");
			ticket_btn.setAttribute("type","button");
			ticket_btn.setAttribute("data-merchant_handle",m.handle);
			ticket_btn.setAttribute("data-total",total_price);
			ticket_btn.setAttribute("data-ticket",r_ticket);
			ticket_btn.setAttribute("data-cart_min",r_min_cart);
			ticket_btn.setAttribute("data-url",kuji_url);
			//ticket_btn.innerHTML = `<span>WIN YOUR CART</span> <span class="small-with">with</span>`+RafLogo+``;
			//ticket_btn.innerHTML = `<span>WIN YOUR CART</span> <span class="small-with">for</span> <b>$`+r_ticket+`</b>`;
			ticket_btn.innerHTML = `<span>WIN IT NOW</span> <span class="small-with">for</span> <b>$`+r_ticket+`</b>`;
			merchant_cart_html.append(ticket_btn)

			if (checkout_available == false){
				ticket_btn.setAttribute('disabled', '');
			} else {
				let shop_url = 'kuji-app'
				if ( m.type == 'retail' ){
					shop_url = m.handle
				}
				let checkout_btn = document.createElement("a");
				checkout_btn.setAttribute("class","checkout-btn button button--full-width button--primary");
				checkout_btn.setAttribute("href",'https://'+shop_url+'.myshopify.com/cart/'+raf_cart_items);
				checkout_btn.innerHTML = 'CHECKOUT';
				merchant_cart_html.append(checkout_btn);
			}

			/* For a link to buy ticket
			let ticket_btn = document.createElement("a");
			ticket_btn.setAttribute("class","button button--full-width button--primary");
			ticket_btn.setAttribute("href",kuji_url);
			ticket_btn.innerHTML = 'Buy a <b>'+Shopify.formatMoney(r_ticket*100, '${{amount}}')+'</b>Ticket';
			merchant_cart_html.append(ticket_btn)*/

		} else {
			alert('kuji is only available on carts less than $3,000')
		}


		cart_obj.appendChild(merchant_cart_html);
	}

	if ( cart != null && cart.length != 0 ) {
		cart_obj.style.display="block";
		document.querySelector('cart-drawer-items').style.display="none";
		document.querySelector('.drawer__footer').style.display="none";

		const empty_container = document.querySelector('.drawer__inner-empty');
		if ( empty_container != null ) {
			empty_container.style.display="none";
		}
	}
}

build_cart(cart)

function show_cart(){
	cart_obj.classList.add("active");
}